// Meta Pixel - loads ONLY after marketing consent. Never send personal or account data.
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const CONSENT_KEY = "bgx_cookie_consent";
const FIRED_KEY = "bgx_pixel_fired";

export function getConsent() {
  try {
    const c = JSON.parse(localStorage.getItem(CONSENT_KEY));
    return c && Date.now() - new Date(c.ts).getTime() < 365 * 864e5 ? c : null;
  } catch { return null; }
}

export function setConsent(marketing) {
  localStorage.setItem(CONSENT_KEY, JSON.stringify({ marketing: !!marketing, ts: new Date().toISOString(), v: 1 }));
  window.dispatchEvent(new Event("bgx-consent"));
  if (marketing) { loadPixel(); trackPageView(); } else revokePixel();
}

const allowed = () => !!PIXEL_ID && getConsent()?.marketing === true;

export function loadPixel() {
  if (!allowed() || window.fbq) {
    if (window.fbq && allowed()) window.fbq("consent", "grant");
    return;
  }
  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.id="meta-pixel-script";
  t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq("consent", "grant");
  window.fbq("init", PIXEL_ID);
}

function revokePixel() {
  if (window.fbq) window.fbq("consent", "revoke");
  const parts = window.location.hostname.split(".");
  const domains = parts.map((_, i) => parts.slice(i).join(".")).filter((d) => d.includes("."));
  ["_fbp", "_fbc"].forEach((n) => {
    document.cookie = `${n}=; Max-Age=0; path=/`;
    domains.forEach((d) => { document.cookie = `${n}=; Max-Age=0; path=/; domain=.${d}`; });
  });
}

function track(event, params, eventID) {
  if (!allowed()) return;
  loadPixel();
  window.fbq("track", event, params || {}, eventID ? { eventID } : undefined);
}

let lastPage = null;
export function trackPageView() {
  const p = window.location.pathname + window.location.search;
  if (p === lastPage || !allowed()) return;
  lastPage = p;
  track("PageView");
}

// fire an event only once per key (survives refreshes) - used for Purchase / Lead
export function trackOnce(key, event, params) {
  if (!allowed()) return;
  let fired = [];
  try { fired = JSON.parse(localStorage.getItem(FIRED_KEY)) || []; } catch { fired = []; }
  if (fired.includes(key)) return;
  track(event, params, key);
  localStorage.setItem(FIRED_KEY, JSON.stringify([...fired, key].slice(-50)));
}

let lastViewed = { id: null, at: 0 };

export const pixel = {
  viewContent: (bot) => {
    if (lastViewed.id === bot.store_id && Date.now() - lastViewed.at < 3000) return;
    lastViewed = { id: bot.store_id, at: Date.now() };
    track("ViewContent", { content_ids: [bot.store_id], content_name: bot.name, content_type: "product", content_category: "MT5 bot" });
  },
  initiateCheckout: (plan, value) => track("InitiateCheckout", { content_name: plan, num_items: 1, ...(value != null ? { value, currency: "GBP" } : {}) }),
  purchase: (sessionId, plan, value, currency) => trackOnce(`purchase:${sessionId}`, "Purchase",
    { value: Number(value), currency: (currency || "gbp").toUpperCase(), content_name: plan, content_type: "product" }),
  lead: (source) => trackOnce(`lead:${source}:${new Date().toISOString().slice(0, 10)}`, "Lead", { content_name: `waitlist-${source}` }),
};
